import request from "@/hooks/useRequest";

export const getCurrencyDetail = (params) => {
  return request("/web-wallet/api/v1/currency", { params });
};
